/**
 * Evaluate if the specified sensor serial number is in the hardware version 1 range.
 * @param serial The sensor serial number to evaluate.
 * @returns If the specified sensor is in the hardware version 1 range.
 */
export function sensorSerialIsForHardwareVersion1(serial: number): boolean {
  return serial < 25000;
}
